import React from "react";
import { Link, useNavigate } from 'react-router-dom';

import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { docColor, iconSize } from "../App/GridRenderers";




const UserGuideIcon = ({ mt = 0 }) => {
    const navigate = useNavigate();
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="User Guide"
                    enterDelay={1000}>
                    <Link
                        to={window.location.origin + "/MyOwnFP%20User%20Guide.pdf"}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon
                            icon={faBook}
                            color={docColor}
                            size={iconSize}
                        />
                    </Link>
                </Tooltip>
            </Stack>
        </div >
    );
};

export default UserGuideIcon;